import { LocalNotifications } from '@capacitor/local-notifications';
import { isNative, platform } from '@/lib/platform';
import { useTaskStore } from '@/stores/taskStore';
import { scheduleNotifications } from './scheduleNotifications';

export async function initNotifications(): Promise<void> {
  if (!isNative()) return;
  try {
    if (platform() === 'android') {
      await LocalNotifications.createChannel({
        id: 'brainday-reminders',
        name: 'Brainday reminders',
        importance: 4,
        visibility: 1,
        vibration: true,
      });
    }

    await LocalNotifications.registerActionTypes({
      types: [
        {
          id: 'TASK_REMINDER',
          actions: [
            { id: 'start', title: 'Start now', foreground: true },
            { id: 'snooze', title: 'Snooze 10m', foreground: true },
          ],
        },
      ],
    });
  } catch {
    // non-fatal — notifications degrade gracefully
  }
}

// Re-schedule whenever tasks change
useTaskStore.subscribe(() => {
  void scheduleNotifications();
});
